// import axios from '@/libs/axios'
import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    suppliers: [],
    suppliersCount: 0,
    supplier: {},
    supplierCodeControl: {},
    supplierSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getSuppliers(state) {
      return state.suppliers
    },
    getSuppliersCount(state) {
      return state.suppliersCount
    },
    getSupplier(state) {
      return state.supplier
    },
    getSupplierCodeControl(state) {
      return state.supplierCodeControl
    },
    getSupplierSaveStatus(state) {
      return state.supplierSave
    },
  },
  mutations: {
    SUPPLIERS_LIST(state, data) {
      state.suppliers = data
    },
    SUPPLIER_VIEW(state, data) {
      state.supplier = data
    },
    SUPPLIERS_COUNT(state, data) {
      state.suppliersCount = data
    },
    SUPPLIERS_SCODE(state, data) {
      state.supplierCodeControl = data
    },
    SUPPLIER_SAVE(state, data) {
      state.supplierSave = data
    },
  },
  actions: {
    suppliersList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/suppliers/getData', data)
        .then(response => {
          commit('SUPPLIERS_LIST', response.data.data)
          commit('SUPPLIERS_COUNT', response.data.count)
          commit('SUPPLIER_SAVE', {
            message: null,
            status: null,
            id: null,
          })
        })
        .catch(error => console.error(error))
    },
    supplierView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'suppliers.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/suppliers/getData', data)
        .then(response => {
          commit('SUPPLIER_VIEW', response.data.data)
          commit('SUPPLIER_SAVE', {
            message: null,
            status: null,
            id: null,
          })
        })
        .catch(error => console.error(error))
    },
    scodeControl({ commit }, checkCode) {
      const data = JSON.stringify({
        select: ['suppliers.id AS id', 'suppliers.company', 'suppliers.name'],
        where: { scode: checkCode },
        array: false,
      })
      axiosIns
        .post('/suppliers/getData', data)
        .then(response => {
          commit('SUPPLIERS_SCODE', response.data.data)
        })
        .catch(error => console.error(error))
    },
    supplierSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/suppliers/saveData', data)
        .then(response => {
          commit('SUPPLIER_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
